import React, { useState, useEffect } from 'react';
import './Payment.scss';
import CardSaved from './components/CardSaved';
import AddButton from './components/AddButton';
import axios from 'axios';
import MethodPayModal from './components/MethodPayModal/';

const Payment = ({membershipData}) => {
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className="myMembership-payment">
      <p className="myMembership-payment-title">Tarjetas de crédito o débito</p>

      <div className="myMembership-payment-list">
{  membershipData && membershipData.cards && membershipData.cards.map((item, index)=>{

            return (
              <div key={index} className="myMembership-payment-listItem">
                <CardSaved info={item}  numItem={index}/>
              </div>
            );
          })}
      </div>

      <AddButton onClick={() => setOpen(true)} />
      <MethodPayModal
        open={open}
        handleClose={handleClose}
        />
    </div>
  );
};

export default Payment;
